<ng-container *ngIf="floatingButtons.activeGroup() as group">
  <ion-fab class="global-floating-buttons" vertical="bottom" [horizontal]="floatingButtons.side()"
    [class.side-start]="floatingButtons.side() === 'start'"
    [class.side-end]="floatingButtons.side() === 'end'">
    <ion-fab-button *ngFor="let action of group.actions" [color]="action.color" [translucent]="action.translucent"
      [class]="action.cssClass || ''" [class.touch-only]="action.touchOnly" [disabled]="action.disabled?.()" [attr.aria-label]="action.label"
      [attr.title]="action.label" (click)="run(action, $event)">
      <ion-icon [name]="action.icon" aria-hidden="true"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ng-container>
